<template>
  <div class="no-data">
    <img src="../assets/image/nodata.png" alt="">
  </div>
</template>

<script >
export default  {}
</script>
<style lang="scss" scoped>
.no-data{
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  margin-top: 0;
  border: 0;
  >img {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>

